import Turbolinks from 'turbolinks';

// Must match the path string in `components/frontend/config/routes.rb`:
// get "/my_inbox_v2" => "my_inboxes_v2#show", as: :my_inbox_v2
// Ruby uses `frontend.my_inbox_v2_path`; this pack cannot read that — if the route path
// or slug ever changes, update this constant (and grep `my_inbox_v2` / `/my_inbox_v2`).
const MY_INBOX_V2_PATH = '/my_inbox_v2';

/**
 * my_inbox_v2 uses React history.pushState/replaceState with `{}` so browser back between
 * conversations does not trigger Turbolinks (which only handles popstate when
 * `history.state.turbolinks` is set). That is correct while the inbox bundle is mounted.
 *
 * After navigating away (e.g. root) Turbolinks advances with its own state. Back to an
 * inbox history entry that has `{}` updates the URL but Turbolinks ignores popstate, so
 * the previous page's body stays visible. If the URL is the inbox but `#my-inbox` is
 * missing, ask Turbolinks to load the page.
 */
function installInboxV2PopstateBridge() {
  if (!Turbolinks.supported || typeof window === 'undefined') return;

  window.addEventListener('popstate', () => {
    if (window.location.pathname !== MY_INBOX_V2_PATH) return;

    // Turbolinks will drive restore for its own entries; don't race a second visit.
    if (window.history.state?.turbolinks) return;

    if (document.getElementById('my-inbox')) return;

    if (typeof window.Turbolinks?.visit !== 'function') return;

    window.Turbolinks.visit(window.location.toString());
  });
}

installInboxV2PopstateBridge();
